import { type FC } from "react"

import { type Course } from "@forento/core/models/course"

import Dropdown from "~/components/Dropdown"

import { Description, Title } from "./styles"

type Props = {
	chapters: Course["chapters"]
	pageCount: number
	onChange(pageCount: number): void
}
// The free preview is the course's first `pageCount` pages, so choosing a page includes every page before it.
const FreePreview: FC<Props> = ({ chapters, pageCount, onChange }) => {
	const pages = chapters.flatMap(chapter =>
		chapter.pages.map(page => ({ title: page.title, group: { id: chapter.id.toString(), title: chapter.title } })),
	)
	const items = [
		{ id: "0", title: "No free preview" },
		...pages.map((page, index) => ({ id: (index + 1).toString(), ...page })),
	]

	return (
		<>
			<Title>Free preview</Title>
			<Description>
				Let visitors try the start of your course before they get access. Choose the last page they can open for
				free; every page before it is included.
			</Description>
			{items.length > 1 ? (
				<>
					<Dropdown
						className="max-w-md"
						items={items}
						selectedItemId={pageCount.toString()}
						onChange={value => onChange(Number(value))}
					/>
					{pageCount > 0 && (
						<p className="mt-2 text-sm text-gray-500">
							Visitors can open the first {pageCount === 1 ? "page" : `${pageCount} pages`}, through{" "}
							{pages[pageCount - 1]?.group.title}.
						</p>
					)}
				</>
			) : (
				<p className="text-gray-500">Add pages to your course to offer a free preview.</p>
			)}
		</>
	)
}

export default FreePreview
